export const InventoryPolicies = {
  CONTINUE: "CONTINUE",
  DENY: "DENY",
};
